import { StarbaseEntity, Serializable } from 'starbase-launcher';
import { ImageFile } from './imageFile';
import { IColumnModel, ColumnModel } from 'table-editor';
import { ITableColumn, TableColumn, ColumnDataTypes } from 'new-table-editor';
import { RelatedSetModel } from './relatedSetModel';

/** Represents a "set" of ImageModel records to be linked together by a name. They are related to each other by undefined qualifiers. */
export class RelatedSetLinkingModel extends StarbaseEntity implements Serializable<RelatedSetLinkingModel> {
    public name: string;
    public relatedSetUID: number;
    public relatedSet: RelatedSetModel;
    public ordnanceReturnSet = false;
    public imageModelId: number;
    public imageModel: ImageFile;
    public sequenceNumber = 0;

    constructor() {
            super(); // Initialize parent with uid
        }

    public static relatedImageSetColumnData(editable: boolean = false): IColumnModel[] {
        return [
            new ColumnModel('Set Name', 'name', 'name', editable, 'string', false, false, 150, false),
            new ColumnModel('Ordnance Return Set', 'ordnanceReturnSet', 'ordnanceReturnSet', false, 'boolean', false, false, 10, false),
            new ColumnModel('Sequence Number', 'sequenceNumber', 'sequenceNumber', editable, 'number', false, false, 50, false),
            new ColumnModel('Created By', 'createdByUser', 'createdByUser', false, 'string', false, false, 100, false),
            new ColumnModel('Created Date/Time', 'createdDateTime', 'createdDateTime', false, 'date', false, false, 100, false),
        ];
    }

    public static relatedImageSetColumns(): ITableColumn[] {
        const nameCol = new TableColumn('name', 'Set Name', ColumnDataTypes.string, true, true, true);
        nameCol.sortingColumn = 'Name';
        const ordCol = new TableColumn('ordnanceReturnSet', 'Ordnance Return Set', ColumnDataTypes.yesno, true, false, false);
        ordCol.sortingColumn = 'OrdnanceReturnSet';
        const seqCol = new TableColumn('sequenceNumber', 'Sequence', ColumnDataTypes.number, true, false, true);
        seqCol.sortingColumn = 'SequenceNumber';
        return [
            nameCol,
            ordCol,
            seqCol,
            ...TableColumn.generateColumnsForStarbaseEntity(false, false, true)
        ];
    }
    
    public static sequenceNumberColumnData(): IColumnModel[] {
        return [
            new ColumnModel('Set Name', 'name', 'name', false, 'string', false, false, 150, false),
            new ColumnModel('Sequence Number', 'sequenceNumber', 'sequenceNumber', true, 'number', false, false, 10, false),
            new ColumnModel('Created By', 'createdByUser', 'createdByUser', false, 'string', false, false, 100, false),
            new ColumnModel('Created Date/Time', 'createdDateTime', 'createdDateTime', false, 'date', false, false, 100, false),
        ];
    }

    deserialize(input) {
      return Object.assign(new RelatedSetLinkingModel(), input);
    }
}
